module.exports = __webpack_public_path__ + "static/media/footer.531d5212.png";